// assets/size-modal.js
document.addEventListener("DOMContentLoaded", () => {
  const boundModals = new WeakSet();

  // Global click delegator to open the modal nearest the trigger
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest && e.target.closest("[data-open-size-modal]");
    if (!openBtn) return;
    e.preventDefault();

    // Scope to nearest picker/section/block if available
    const container =
      openBtn.closest("variant-picker") ||
      openBtn.closest("[data-block-id]") ||
      openBtn.closest("[data-section-id]") ||
      document;

    // Prefer scoped modal, fallback to first .size-modal
    let modal = null;
    if (container && container !== document) {
      modal = container.querySelector(".size-modal");
      if (!modal && container.dataset.blockId) {
        modal = container.querySelector(`#sizeModal-${container.dataset.blockId}`);
      }
    }
    if (!modal) modal = document.querySelector(".size-modal");
    if (!modal) return;

    // Open modal & disable page scroll
    modal.removeAttribute("hidden");
    document.body.style.overflow = "hidden";

    // Bind close handlers (only once per modal instance)
    if (!boundModals.has(modal)) {
      const closeBtns = modal.querySelectorAll(
        "[data-close-size-modal], .size-modal__close, .find-my-size-close"
      );
      const overlay = modal.querySelector(".size-modal__overlay");

      const closeModal = (ev) => {
        if (ev && typeof ev.preventDefault === "function") ev.preventDefault();
        modal.setAttribute("hidden", "");
        document.body.style.overflow = "";
      };

      // Attach click handlers with preventDefault
      closeBtns.forEach((btn) => {
        btn.addEventListener("click", closeModal);
      });

      if (overlay) {
        overlay.addEventListener("click", closeModal);
      }

      boundModals.add(modal);
    }

    // Move focus into modal (first focusable or the modal)
    const focusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    (focusable || modal).focus && (focusable || modal).focus();
  });

  // Global ESC handler to close any open size-modal(s)
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const openModals = document.querySelectorAll(".size-modal:not([hidden])");
      if (openModals.length) {
        openModals.forEach((m) => {
          m.setAttribute("hidden", "");
        });
        document.body.style.overflow = "";
      }
    }
  });

  // Allow Enter/Space to activate focused trigger elements
  document.addEventListener("keydown", (e) => {
    const active = document.activeElement;
    if (!active) return;
    if (!active.hasAttribute || !active.hasAttribute("data-open-size-modal")) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      active.click();
    }
  });
});
